module.exports = __webpack_public_path__ + "static/media/WHO_WE_HELP.8087767d.png";